import {
  accessMappingPropertyData,
  AccessMappingPropertyDataType,
} from "./helper";

const useShowPropertyStoreRevType = (
  propertyType: string | null,
  whatToDo: AccessMappingPropertyDataType
) => {
  if (propertyType === null || propertyType === undefined) return false;

  const allowedStatuses: string[] = accessMappingPropertyData[whatToDo];
  return allowedStatuses.indexOf(propertyType) !== -1;
};

export default useShowPropertyStoreRevType;
